var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "th",
      {
        on: {
          click: function($event) {
            return _vm.toggleHourlyUsage(_vm.usage.date)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "date expand-toggle",
            class: { expanded: _vm.isExpanded }
          },
          [
            _vm._v(
              _vm._s(_vm.formatDate(_vm.usage.date, "short")) + "\n        "
            ),
            _c("span", [
              _c(
                "svg",
                {
                  attrs: {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("circle", {
                    attrs: { cx: "12", cy: "12", r: "12", fill: "#DADADA" }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M12 6V18M18 12L6 12",
                      stroke: "#202020",
                      "stroke-width": "2px"
                    }
                  })
                ]
              )
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("td", [
      _c("div", { staticClass: "day-of-week" }, [
        _vm._v(_vm._s(_vm.getDayOfWeek(_vm.usage.date, "long")))
      ])
    ]),
    _vm._v(" "),
    _vm.isNetMetered
      ? _c("td", [
          _c(
            "div",
            {
              staticClass: "net-use-circle",
              class: {
                negative: _vm.usage.returnedGeneration < _vm.usage.consumedTotal
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.netUsage(
                      _vm.usage.returnedGeneration,
                      _vm.usage.consumedTotal
                    )
                  ) +
                  "\n      "
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isNetMetered
      ? _c(
          "td",
          {
            staticClass: "usage-detail__data-series",
            attrs: { "data-series": "totalEnergyUsed" }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("numberCommaSingleDecimal")(_vm.usage.totalEnergyUsed)
                ) +
                " "
            ),
            _c("span", { staticClass: "unit" }, [_vm._v("kWh")]),
            _vm._v(" "),
            _c("Usage-Consumption-Bar-CSS", {
              attrs: {
                series1: _vm.usage.totalEnergyUsed,
                maxUsageValue: _vm.maxUsageValue
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isNetMetered
      ? _c(
          "td",
          {
            staticClass: "usage-detail__data-series",
            attrs: { "data-series": "generation" }
          },
          [
            _c("span", { staticClass: "main-series" }, [
              _vm._v(
                _vm._s(
                  _vm._f("numberCommaSingleDecimal")(
                    _vm.determineGenerationAmount(_vm.usage)
                  )
                ) + " "
              ),
              _c("span", { staticClass: "unit" }, [_vm._v("kWh")])
            ]),
            _vm._v(" "),
            _vm.usage.returnedGeneration != undefined
              ? _c("span", { staticClass: "sub-series parenthesis-wide" }, [
                  _vm.usage.generation != undefined &&
                  _vm.usage.generation &&
                  _vm.usage.returnedGeneration > 0
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberCommaSingleDecimal")(
                              _vm.usage.generation -
                                _vm.usage.returnedGeneration
                            )
                          ) + " "
                        ),
                        _c("span", { staticClass: "unit" }, [
                          _vm._v("kWh to home,")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "sub-series" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberCommaSingleDecimal")(
                          _vm.usage.returnedGeneration
                        )
                      ) + " "
                    ),
                    _vm.usage.returnedGeneration != undefined
                      ? _c("span", { staticClass: "unit" }, [
                          _vm._v("kWh to grid")
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.usage.returnedGeneration == undefined
              ? _c("span", { staticClass: "sub-series parenthesis-wide" }, [
                  _vm.usage.generation != undefined && _vm.usage.generation
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("numberCommaSingleDecimal")(
                              _vm.usage.generation
                            )
                          ) + " "
                        ),
                        _c("span", { staticClass: "unit" }, [
                          _vm._v("kWh to home,")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("Usage-Consumption-Bar-CSS", {
              attrs: {
                series1: _vm.usage.generation - _vm.usage.returnedGeneration,
                series2: _vm.usage.returnedGeneration,
                maxUsageValue: _vm.maxUsageValue
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.hasTOU
      ? _c(
          "td",
          {
            staticClass: "usage-detail__data-series",
            attrs: { "data-series": "consumedTotal" }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("numberCommaSingleDecimal")(_vm.usage.consumedTotal)
                ) +
                " "
            ),
            _c("span", { staticClass: "unit" }, [_vm._v("kWh")]),
            _vm._v(" "),
            _c("Usage-Consumption-Bar-CSS", {
              attrs: {
                series1: _vm.usage.consumedTotal,
                maxUsageValue: _vm.maxUsageValue
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasTOU
      ? _c(
          "td",
          {
            staticClass: "usage-detail__data-series",
            attrs: { "data-series": "consumedTOU" }
          },
          [
            _c("span", { staticClass: "main-series" }, [
              _vm._v(
                _vm._s(
                  _vm._f("numberCommaSingleDecimal")(_vm.usage.consumedTotal)
                ) + " "
              ),
              _c("span", { staticClass: "unit" }, [_vm._v("kWh")])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sub-series parenthesis-wide" }, [
              _c("span", { staticClass: "sub-series" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("numberCommaSingleDecimal")(_vm.getOnPeakUsage)
                  ) + " "
                ),
                _c("span", { staticClass: "unit" }, [_vm._v("kWh Peak,")])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "sub-series" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("numberCommaSingleDecimal")(_vm.getOffPeakUsage)
                    ) +
                    " "
                ),
                _c("span", { staticClass: "unit" }, [_vm._v("kWh Off Peak")])
              ])
            ]),
            _vm._v(" "),
            _c("Usage-Consumption-Bar-CSS", {
              attrs: {
                series1: _vm.getOnPeakUsage,
                series2: _vm.getOffPeakUsage,
                maxUsageValue: _vm.maxUsageValue
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasEvCharger
      ? _c(
          "td",
          {
            staticClass: "usage-detail__data-series",
            attrs: { "data-series": "evCharger" }
          },
          [
            !_vm.evChargerHasValue ? _c("span", [_vm._v(" ")]) : _vm._e(),
            _vm._v(" "),
            _vm.evChargerHasValue
              ? _c(
                  "span",
                  [
                    _c("span", { staticClass: "main-series" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("numberCommaSingleDecimal")(
                            _vm.getTotalEvCharger
                          )
                        ) + " "
                      ),
                      _c("span", { staticClass: "unit" }, [_vm._v("kWh")])
                    ]),
                    _vm._v(" "),
                    _vm.evChargerHasPeakAndOffPeak
                      ? _c(
                          "span",
                          { staticClass: "sub-series parenthesis-wide" },
                          [
                            _c("span", { staticClass: "sub-series" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberCommaSingleDecimal")(
                                    _vm.getOnPeakEvCharger
                                  )
                                ) + " "
                              ),
                              _c("span", { staticClass: "unit" }, [
                                _vm._v("kWh Peak,")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "sub-series" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("numberCommaSingleDecimal")(
                                      _vm.getOffPeakEvCharger
                                    )
                                  ) +
                                  " "
                              ),
                              _c("span", { staticClass: "unit" }, [
                                _vm._v("kWh Off Peak")
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Usage-Consumption-Bar-CSS", {
                      attrs: {
                        series1: _vm.getOnPeakEvCharger,
                        series2: _vm.getOffPeakEvCharger,
                        maxUsageValue: _vm.maxUsageValue
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasSnapshotData && !_vm.isNetMetered
      ? _c("td", { staticClass: "usage-detail__spark-chart" }, [
          _vm.usage.date &&
          !_vm.isTodayOrYesterday(_vm.usage.date) &&
          _vm.dailyUsagePeriodValues &&
          _vm.dailyUsagePeriodValues.length > 0
            ? _c(
                "div",
                { staticClass: "usage-detail__spark-chart-container" },
                [
                  _c(
                    "span",
                    { staticClass: "usage-detail__highest-usage-period" },
                    [_vm._v(_vm._s(_vm.usage.highestUsagePeriodOfDay))]
                  ),
                  _vm._v(" "),
                  _c("HighestUsageMicroSparkbar", {
                    staticClass: "usage-detail__spark-chart",
                    attrs: { data: _vm.dailyUsagePeriodValues }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("td", { staticClass: "usage-detail__temp" }, [
      _vm._v(
        _vm._s(
          _vm.getTemperature(_vm.usage).low
            ? _vm.getTemperature(_vm.usage).low + "°F"
            : ""
        )
      )
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "usage-detail__temp" }, [
      _vm._v(
        _vm._s(
          _vm.getTemperature(_vm.usage).high
            ? _vm.getTemperature(_vm.usage).high + "°F"
            : ""
        )
      )
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "usage-detail__weather" }, [
      _vm.usage.weatherIcon
        ? _c("img", {
            staticClass: "usage-detail__weather-image",
            attrs: {
              src: _vm.weatherImagePath + _vm.usage.weatherIconImageUrl,
              alt: "Weather Icon"
            }
          })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "sub-series" }, [
      _c("span", { staticClass: "unit" }, [_vm._v("0 kWh to grid")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }